import LoginPassword       from "../../../domain/authentication/LoginPassword";
import GenderType          from "../../../domain/fundamentals/gender/GenderType";
import FirstName           from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana       from "../../../domain/fundamentals/name/FirstNameKana";
import LastName            from "../../../domain/fundamentals/name/LastName";
import LastNameKana        from "../../../domain/fundamentals/name/LastNameKana";
import Staff               from "../../../domain/staff/Staff";
import StaffId             from "../../../domain/staff/StaffId";
import StaffMemo           from "../../../domain/staff/StaffMemo";
import StaffRepository     from "../../../domain/staff/StaffRepository";
import Staffs              from "../../../domain/staff/Staffs";
import { ApiClient }       from "../../configure/ApiClientConfig";
import {
  setStaffAction,
  setStaffFirstNameAction,
  setStaffFirstNameKanaAction,
  setStaffGenderTypeAction,
  setStaffLastNameAction,
  setStaffLastNameKanaAction,
  setStaffMemoAction
}                          from "../../redux/staff/StaffAction";
import { setStaffsAction } from "../../redux/staff/StaffsAction";

class StaffDataSource implements StaffRepository {
  constructor(private readonly dispatch) {
  }

  findAll() {
    return ApiClient.get("/staffs");
  }

  findBy(staffId: StaffId) {
    return ApiClient.get("/staff", {
      params: {
        staffId: staffId.value,
      }
    });
  }

  findByAccount() {
    return ApiClient.get("/staff/account");
  }

  register(staff: Staff, loginPassword: LoginPassword) {
    return ApiClient.post("/staff", {
      last_name: staff.name.lastName.value,
      first_name: staff.name.firstName.value,
      last_name_kana: staff.name.lastNameKana.value,
      first_name_kana: staff.name.firstNameKana.value,
      gender: staff.genderType,
      memo: staff.memo.value,
      password: loginPassword.value
    });
  }

  changePassword(staffId: StaffId, currentPassword: LoginPassword, newPassword: LoginPassword, confirmPassword: LoginPassword) {
    return ApiClient.put("staff/password", {
      currentPassword: currentPassword.value,
      newPassword: newPassword.value,
      confirmPassword: confirmPassword.value,
    }, {
      params: {
        staffId: staffId.value
      }
    })
  }

  update(staff: Staff) {
    return ApiClient.put("/staff", {
      id: staff.id.value,
      last_name: staff.name.lastName.value,
      first_name: staff.name.firstName.value,
      last_name_kana: staff.name.lastNameKana.value,
      first_name_kana: staff.name.firstNameKana.value,
      gender: staff.genderType,
      memo: staff.memo.value,
    });
  }

  delete(staffId: StaffId) {
    return ApiClient.delete("/staff", {
      params: {
        staffId: staffId.value
      }
    });
  }

  checkLimit() {
    return ApiClient.get("/corporation/contract/plan/staff/limit");
  }

  setStaffs(staffs: Staffs) {
    this.dispatch(setStaffsAction(staffs));
  }

  setStaff(staff: Staff) {
    this.dispatch(setStaffAction(staff));
  }

  setLastName(lastName: LastName) {
    this.dispatch(setStaffLastNameAction(lastName));
  }

  setFirstName(firstName: FirstName) {
    this.dispatch(setStaffFirstNameAction(firstName));
  }

  setLastNameKana(lastNameKana: LastNameKana) {
    this.dispatch(setStaffLastNameKanaAction(lastNameKana));
  }

  setFirstNameKana(firstNameKana: FirstNameKana) {
    this.dispatch(setStaffFirstNameKanaAction(firstNameKana));
  }

  setGenderType(genderType: GenderType) {
    this.dispatch(setStaffGenderTypeAction(genderType));
  }

  setMemo(memo: StaffMemo) {
    this.dispatch(setStaffMemoAction(memo));
  }
}

export default StaffDataSource;
